import React from "react";

const PlusIcon = ({name, color, size}) => (
<svg viewBox="0 0 42 42" className={`icon icon-${name}`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
    <path d="M42 20H22V0h-2v20H0v2h20v20h2V22h20z" />
</svg>
);

export default PlusIcon;